import { belongsTo } from '@ember-data/model';
import Super from './document-request';

export default class DocumentRequestContactInfo extends Super {
  documentIcon = 'user';
  mixpanelType = 'Demographic info';

  @belongsTo('document-request-contact-info-connection', { async: false, inverse: null })
  connection;

  @belongsTo('demographics-form', {
    async: false,
    inverse: 'documentRequestContactInfo',
  })
  demographicsForm;
}
